export const continents = [
  {
    text: "General",
    expanded: true,
    items: [
      {
        text: "Personal",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        selected: true,
        flag: "images/flags/Egypt.svg",
        cities: [
          {
            text: "Basic info",
            template: "tBasic",
            disabled: false,
          },
          {
            text: "Keluarga",
            template: "tKeluarga",
            // disabled: true, kalau mau tab disabled
            disabled: false,
          },
        ],
      },
      {
        text: "Employment",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        flag: "images/flags/SouthAfrica.svg",
        cities: [
          {
            text: "Current Employment",
            template: "tEmploymentCurr",
          },
          {
            text: "Employment history",
            template: "tEmployment",
          },
        ],
      },
      {
        text: "Education & Experience",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        flag: "images/flags/SouthAfrica.svg",
        cities: [
          {
            text: "Formal education",
            template: "tEdFormal",
          },
          {
            text: "Informal education",
            template: "tEdInformal",
          },
          {
            text: "Working experience",
            template: "tEdWorking",
          },
        ],
      },
    ],
  },
  {
    text: "Time Management",
    expanded: false,
    items: [
      {
        text: "Absensi",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",

        flag: "images/flags/Egypt.svg",
        cities: [],
      },
      {
        text: "Timeoff",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",

        flag: "images/flags/Egypt.svg",
        cities: [],
      },
      {
        text: "Overtime",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",

        flag: "images/flags/Egypt.svg",
        cities: [],
      },
    ],
  },

  {
    text: "Payroll",
    expanded: false,
    items: [
      {
        text: "Payroll info",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",

        flag: "images/flags/Egypt.svg",
        cities: [],
      },
    ],
  },
  {
    text: "Finance",
    expanded: false,
    items: [
      {
        text: "Reimbursement",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        flag: "images/flags/Egypt.svg",
        cities: [],
      },
      {
        text: "Loan",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        flag: "images/flags/Egypt.svg",
        cities: [],
      },
      {
        text: "Cash Advance",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        flag: "images/flags/Egypt.svg",
        cities: [],
      },
    ],
  },
  {
    text: "Files",
    expanded: false,
    items: [
      {
        text: "Files info",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        flag: "images/flags/Egypt.svg",
        cities: [],
      },
    ],
  },
  {
    text: "Assets",
    expanded: false,
    items: [
      {
        text: "Assets info",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        flag: "images/flags/Egypt.svg",
        cities: [],
      },
    ],
  },
  {
    text: "History",
    expanded: false,
    items: [
      {
        text: "Employee history",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        flag: "images/flags/Egypt.svg",
        cities: [],
      },
      {
        text: "Adjustment history",
        fullName: "Ayu Anggraeni",
        description: "Staf TI - Litbang",
        flag: "images/flags/Egypt.svg",
        cities: [],
      },
    ],
  },
];
